'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UNINITIALIZED = exports.UNINITIALIZED = 'UNINITIALIZED';
var STARTED = exports.STARTED = 'STARTED';
var SUCCEEDED = exports.SUCCEEDED = 'SUCCEEDED';
var FAILED = exports.FAILED = 'FAILED';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/async-data/constants/asyncStatuses.js
// module id = 58
// module chunks = 2 3